import type { AuditEventView } from '@/types/api';
import { apiPage, withQuery } from '@/api/client';

export interface AuditFilter {
  /** One action, or a family of them with a trailing dot: `user.` is every user action. */
  action?: string;
  result?: string;
  /** What the events are about: a server's journal (ADR-0058). */
  entityType?: string;
  entityId?: string;
  limit: number;
  cursor?: string | null;
}

/** The audit trail: read-only, newest first. */
export const auditApi = {
  list: (filter: AuditFilter) => {
    const params = new URLSearchParams({ limit: String(filter.limit) });
    if (filter.action) params.set('action', filter.action);
    if (filter.result) params.set('result', filter.result);
    if (filter.entityType) params.set('entityType', filter.entityType);
    if (filter.entityId) params.set('entityId', filter.entityId);
    if (filter.cursor) params.set('cursor', filter.cursor);
    return apiPage<AuditEventView>(withQuery('/audit', params));
  },
};
